
import Stickyfill from '../../plugins/stickyfill.js';



let url = location.href;
if(url.indexOf("?id=") != -1){
    let id = url.split("?id=");
    let $target = $('#' + id[id.length - 1]);
    //console.log($target);
    if($target.length){
        let position = $target.offset().top;
        $("html, body").animate({scrollTop:position + 10}, 1);
    }
}




var elements = document.querySelectorAll(".sticky");
Stickyfill.add(elements);



window.onscroll = function () {

  //有資格者一覧の時
  if($("#business-qualified").length){
    scrollToggleClass("#area01", ".p-follow-nav .-area01", "js-area-active", '-area01');
    scrollToggleClass("#area02", ".p-follow-nav .-area02", "js-area-active", '-area02');
    scrollToggleClass("#area03", ".p-follow-nav .-area03", "js-area-active", '-area03');
    scrollToggleClass("#area04", ".p-follow-nav .-area04", "js-area-active", '-area04');
    scrollToggleClass("#area05", ".p-follow-nav .-area05", "js-area-active", '-area05');
  }

  //業務実績一覧 建築関係建設コンサルタント業務
  if($("#achievement01").length && $('.achievement01').css('display') == 'block'){
    scrollToggleClass2("#area01-1", ".p-follow-nav .-area01-1", "js-area-active", '-area01-1', '1');
    scrollToggleClass2("#area01-2", ".p-follow-nav .-area01-2", "js-area-active", '-area01-2', '1');
    scrollToggleClass2("#area01-3", ".p-follow-nav .-area01-3", "js-area-active", '-area01-3', '1');
    scrollToggleClass2("#area01-4", ".p-follow-nav .-area01-4", "js-area-active", '-area01-4', '1');
    scrollToggleClass2("#area01-5", ".p-follow-nav .-area01-5", "js-area-active", '-area01-5', '1');
    scrollToggleClass2("#area01-6", ".p-follow-nav .-area01-6", "js-area-active", '-area01-6', '1');
    scrollToggleClass2("#area01-7", ".p-follow-nav .-area01-7", "js-area-active", '-area01-7', '1');
    scrollToggleClass2("#area01-8", ".p-follow-nav .-area01-8", "js-area-active", '-area01-8', '1');
    scrollToggleClass2("#area01-9", ".p-follow-nav .-area01-9", "js-area-active", '-area01-9', '1');
    scrollToggleClass2("#area01-10", ".p-follow-nav .-area01-10", "js-area-active", '-area01-10', '1');
    scrollToggleClass2("#area01-11", ".p-follow-nav .-area01-11", "js-area-active", '-area01-11', '1');
  }

  //業務実績一覧 測量業務
  // if($("#achievement02").length && $('.achievement02').css('display') == 'block'){
  //   scrollToggleClass2("#area02-1", ".p-follow-nav .-area02-1", "js-area-active", '-area02-1', '2');
  // }

  //業務実績一覧 地質業務
  // if($("#achievement03").length && $('.achievement03').css('display') == 'block'){
  //   scrollToggleClass2("#area03-1", ".p-follow-nav .-area03-1", "js-area-active", '-area03-1', '3');
  //   scrollToggleClass2("#area03-2", ".p-follow-nav .-area03-2", "js-area-active", '-area03-2', '3');
  //   scrollToggleClass2("#area03-3", ".p-follow-nav .-area03-3", "js-area-active", '-area03-3', '3');
  //   scrollToggleClass2("#area03-4", ".p-follow-nav .-area03-4", "js-area-active", '-area03-4', '3');
  // }

  //業務実績一覧 土木関係建設コンサルタント業務
  if($("#achievement04").length && $('.achievement04').css('display') == 'block'){
    scrollToggleClass2("#area04-1", ".p-follow-nav .-area04-1", "js-area-active", '-area04-1', '4');
    scrollToggleClass2("#area04-5", ".p-follow-nav .-area04-5", "js-area-active", '-area04-5', '4');
    scrollToggleClass2("#area04-2", ".p-follow-nav .-area04-2", "js-area-active", '-area04-2', '4');
    scrollToggleClass2("#area04-3", ".p-follow-nav .-area04-3", "js-area-active", '-area04-3', '4');
    scrollToggleClass2("#area04-4", ".p-follow-nav .-area04-4", "js-area-active", '-area04-4', '4');
    scrollToggleClass2("#area04-6", ".p-follow-nav .-area04-6", "js-area-active", '-area04-6', '4');
  }

  //業務実績一覧 補償関係コンサルタント業務
  // if($("#achievement05").length && $('.achievement05').css('display') == 'block'){
  //   scrollToggleClass2("#area05-1", ".p-follow-nav .-area05-1", "js-area-active", '-area05-1', '5');
  // }

  //業務実績一覧 土木関係建設コンサルタント業務
  // if($("#achievement06").length && $('.achievement06').css('display') == 'block'){
  //   scrollToggleClass2("#area06-1", ".p-follow-nav .-area06-1", "js-area-active", '-area06-1', '6');
  //   scrollToggleClass2("#area06-2", ".p-follow-nav .-area06-2", "js-area-active", '-area06-2', '6');
  // }



}



function scrollToggleClass(rangeTarget, addTarget, classname, classname2) {
  if($(rangeTarget).length){

    let result = Number(rangeTarget.substr(6));
    result = '#area0' + (result + 1);
    let nav = '.p-follow-nav__item';
    let scroll = $(window).scrollTop();
    let startPos = $(rangeTarget).offset().top - 20;
    let endPos = 0;
    let maxLength = "";

    //有資格者一覧の時
    if($("#business-qualified").length){
      maxLength = $("#business-qualified .p-follow-nav li").length;
      maxLength = "#area0" + maxLength;
    }

    if(rangeTarget == maxLength) {
      endPos = startPos + $(rangeTarget).outerHeight();
    } else {
      endPos = $(result).offset().top;
    }

    if (scroll > startPos && scroll < endPos) {
        $(addTarget).addClass(classname);
        $(nav + '.' + classname2).addClass(classname);
    } else {
        $(addTarget).removeClass(classname);
        $(nav + '.' + classname2).removeClass(classname);
    }

  }
}


function scrollToggleClass2(rangeTarget, addTarget, classname, classname2, tabNum) {
  if($(rangeTarget).length){

    let result = Number(rangeTarget.substr(8));
    result = '#area0'+ tabNum+ '-' + (result + 1);
    //console.log(result);
    let nav = '.p-follow-nav__item';
    let scroll = $(window).scrollTop();
    let startPos = $(rangeTarget).offset().top;
    let endPos = 0;
    let maxLength = "";

    //建築関係建設コンサルタント業務
    if($("#achievement01").length && $('.achievement01').css('display') == 'block'){
      maxLength = $("#achievement01 .p-follow-nav li").length;
      maxLength = "#area0"+ tabNum+ '-'  + maxLength;
    }

    //測量業務
    // if($("#achievement02").length && $('.achievement02').css('display') == 'block'){
    //   maxLength = $("#achievement02 .p-follow-nav li").length;
    //   maxLength = "#area0"+ tabNum+ '-'  + maxLength;
    // }

    //地質調査業務
    if($("#achievement03").length && $('.achievement03').css('display') == 'block'){
      maxLength = $("#achievement03 .p-follow-nav li").length;
      maxLength = "#area0"+ tabNum+ '-'  + maxLength;
    }

    //土木関係建設コンサルタント業務
    if($("#achievement04").length && $('.achievement04').css('display') == 'block'){
      maxLength = $("#achievement04 .p-follow-nav li").length;
      maxLength = "#area0"+ tabNum+ '-'  + maxLength;
    }

    //補償関係コンサルタント業務
    // if($("#achievement05").length && $('.achievement05').css('display') == 'block'){
    //   maxLength = $("#achievement05 .p-follow-nav li").length;
    //   maxLength = "#area0"+ tabNum+ '-'  + maxLength;
    // }

    //下水道管維持
    if($("#achievement06").length && $('.achievement06').css('display') == 'block'){
      maxLength = $("#achievement06 .p-follow-nav li").length;
      maxLength = "#area0"+ tabNum+ '-'  + maxLength;
    }


    if(rangeTarget == maxLength) {
      endPos = startPos + $(rangeTarget).outerHeight();
    } else {
      endPos = $(result).offset().top;
    }

    if (scroll > startPos && scroll < endPos) {
        $(addTarget).addClass(classname);
        $(nav + '.' + classname2).addClass(classname);
    } else {
        $(addTarget).removeClass(classname);
        $(nav + '.' + classname2).removeClass(classname);
    }

  }
}


  